export default "__VITE_ASSET__5bGdkwfr__"